import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import './layout.scss';

function Layout({ children, onHeaderAction }) {
  // Handle header button clicks and pass them to the parent component
  window.scrollTo(0, 0, 'smooth');
  const handleHeaderButtonClick = (action) => {
    if (onHeaderAction) {
      onHeaderAction(action);
    }
  };

  return (
    <div className="layout-wrap">
      <Header onClick={handleHeaderButtonClick} />
      <main>{children}</main>
      <Footer />
    </div>
  );
}

export default Layout;
